module.exports = "https://static.wanderu.com/ui-react/_next/static/media/fast-buses.6dfeee83.png";